import { AppState } from 'types/AppState';

// keys that needed to persist project (also used in templates)

export const projectPersistKeys: (keyof AppState)[] = [
  'scenes',
  'ratioFormat',
  'effects',
  'audio',
  'sceneVolume',
  'revisions',
  'checkoutModal'
];

export const appPersistKeys: (keyof AppState)[] = ['downloading', 'template', 'persistedSettings'];
